
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index9KuVwq87LUWEwtfG1aGyBXrlDlGQzPXel59DVUMMKAIMeta } from "/home/runner/work/hive-ui/hive-ui/pages/index.vue?macro=true";
import { default as vault7dvojc3_45Ljkv2G9BXy4f66egKaCj41dC0rtJ4Uk7k5gMeta } from "/home/runner/work/hive-ui/hive-ui/pages/vault.vue?macro=true";
import { default as familysEYAYejF7cIVasSq1YwfB_45k5ZfT_nF4mI_gD0VpfM4EMeta } from "/home/runner/work/hive-ui/hive-ui/pages/family.vue?macro=true";
import { default as detailsXEy1Ih8RgAPFuflbDO2_7ppgWTzkxisJc_0zyxRvFZMMeta } from "/home/runner/work/hive-ui/hive-ui/pages/details.vue?macro=true";
import { default as reportsz4j7ZUlbI8goQAy2_45t9J6rixT_459dDh0RYa1x6Xnq9D0Meta } from "/home/runner/work/hive-ui/hive-ui/pages/reports.vue?macro=true";
import { default as contacts5xZmvWRti_45_bpH9ioF3wbIQ9G2ARNhfqeaHvcsGJYSUMeta } from "/home/runner/work/hive-ui/hive-ui/pages/contacts.vue?macro=true";
import { default as lpoaIPd_456E_vjEdF4STEF4cGkaZ_45js00mAjT3MWHhJ0wJsMMeta } from "/home/runner/work/hive-ui/hive-ui/pages/settings/lpoa.vue?macro=true";
import { default as indexQgdTMwGOZfYXVdyWm_45g0vmSKg1sq2c2_45fBhV3N_LNMcMeta } from "/home/runner/work/hive-ui/hive-ui/pages/settings/index.vue?macro=true";
import { default as billing2wBdUorGldV4Z8_45L_45CdofiRebVVaJBHYwM1USk_vgn8Meta } from "/home/runner/work/hive-ui/hive-ui/pages/settings/billing.vue?macro=true";
import { default as controls3NaNlpn86HIoNcFAW6wEotvSJveS_3oiB1Ej99equ2kMeta } from "/home/runner/work/hive-ui/hive-ui/pages/settings/controls.vue?macro=true";
import { default as securityUqcbUu8jLymX5y8Qy5mlDhj_0VaWz1fGd8e3JiU4cbYMeta } from "/home/runner/work/hive-ui/hive-ui/pages/settings/security.vue?macro=true";
import { default as monitoringEpeA2bGOZgJUrpqXN2aqrub0VjOnaMCeVWnRxj5q4ooMeta } from "/home/runner/work/hive-ui/hive-ui/pages/settings/monitoring.vue?macro=true";
import { default as notificationspSNAumhLS0uZWHVr8oA25xn5WVmlRL5iVFivbHGOCoQMeta } from "/home/runner/work/hive-ui/hive-ui/pages/settings/notifications.vue?macro=true";
import { default as settingsLLG8Vypm1_45rrnXWYDS6564Phtljcu44QXEa_457pqXeBQMeta } from "/home/runner/work/hive-ui/hive-ui/pages/settings.vue?macro=true";
import { default as dashboardoEASKepHfEO0KtqzZvk1eOFCDxzhg8JGLVLGpig_9skMeta } from "/home/runner/work/hive-ui/hive-ui/pages/dashboard.vue?macro=true";
import { default as not_45foundbe7C5B5mZinpsFleG2Ls4nXq1kODxTU1FiB7Z2xK5sYMeta } from "/home/runner/work/hive-ui/hive-ui/pages/not-found.vue?macro=true";
import { default as loginN5GUm_RH2lzdErTSMBNVGscLkuSXQi9WdZOoFeifEXwMeta } from "/home/runner/work/hive-ui/hive-ui/pages/auth/login.vue?macro=true";
import { default as radarCjl1nXC0MVpdG_DMWMUhfRYscfM5kF6lTJSgJ_45nhlvEMeta } from "/home/runner/work/hive-ui/hive-ui/pages/buzz/radar.vue?macro=true";
import { default as logoutsLqxcvZTBUAGo8U0yb8QaK1tu6flvl11BVoYuNXjeokMeta } from "/home/runner/work/hive-ui/hive-ui/pages/auth/logout.vue?macro=true";
import { default as data_45brokersIBGn34ciNsUPugKHQfhzya80HG6cIHXe_8q_45bakZVYAMeta } from "/home/runner/work/hive-ui/hive-ui/pages/data-brokers.vue?macro=true";
import { default as callbackJxJppHg3Nso63D5V4IqVmYLmiRV4ZQz416Zy2hIU5d4Meta } from "/home/runner/work/hive-ui/hive-ui/pages/auth/callback.vue?macro=true";
import { default as dark_45web_45scanSzNgHczSpieF3Rlxk9z7ml6JQjrheSSmk_45wMV_B5CiYMeta } from "/home/runner/work/hive-ui/hive-ui/pages/dark-web-scan.vue?macro=true";
import { default as risk_45chart4i1jJdkrc_45OnvHz0G_45BZP3OHHxzCHp03qQOtN_45cw_vIMeta } from "/home/runner/work/hive-ui/hive-ui/pages/buzz/risk-chart.vue?macro=true";
import { default as indexRqHWElTahGBDXs9I_D174sG2Pw_45fMcQwCKeSfXMTynoMeta } from "/home/runner/work/hive-ui/hive-ui/pages/companies/index.vue?macro=true";
import { default as search_45presence_hHoYSdj_45hopCpUuNYZZ4Wr1gqKnGDChxWK9zAMofhQMeta } from "/home/runner/work/hive-ui/hive-ui/pages/search-presence.vue?macro=true";
import { default as indexxHdboUg2NB7i3fHvui9lUmiCrkpGuEblux2D2HR9B_EMeta } from "/home/runner/work/hive-ui/hive-ui/pages/university/index.vue?macro=true";
import { default as dashboardU9hNSQvwEtHWVBo9asA6SrZjPsFRXHm_4JsPjY2gbBIMeta } from "/home/runner/work/hive-ui/hive-ui/pages/personal/dashboard.vue?macro=true";
import { default as authedy6Rx5Q2xar5Tlz1kSGlcfFphywKmdyREnLsGlEmlClgMeta } from "/home/runner/work/hive-ui/hive-ui/pages/support-lab/authed.vue?macro=true";
import { default as publicztsZeW0KX7spIle29YzORigSD9xEHfsf3LANcOdUJNgMeta } from "/home/runner/work/hive-ui/hive-ui/pages/support-lab/public.vue?macro=true";
import { default as _91_91category_93_93J4u4U_Tq_45SU0oXScnu3zHegLpr1qN8KGf22iqY4AwXMMeta } from "/home/runner/work/hive-ui/hive-ui/pages/brokers/[[category]].vue?macro=true";
import { default as appsEW4zQ2fr23nLfb3Fhol0ebXD0V_tZ0cw_WBBSbAM5_45oMeta } from "/home/runner/work/hive-ui/hive-ui/pages/business/[slug]/apps.vue?macro=true";
import { default as indexho_TGBqEHTCWa0Ul8PzmzZRATxSazrMiXvWnOsfLqMsMeta } from "/home/runner/work/hive-ui/hive-ui/pages/business/[slug]/index.vue?macro=true";
import { default as _91token_93RRxVG8tuaVMvbHLEDdSHe4ZebMltnndk0s3eWar_453Q4Meta } from "/home/runner/work/hive-ui/hive-ui/pages/consent/minor/[token].vue?macro=true";
import { default as _91tab_93oa4ikMo3GKl2wXrjV_45gTMsZDhuC0cXLUBVP3mIF1_vYMeta } from "/home/runner/work/hive-ui/hive-ui/pages/companies/[slug]/[tab].vue?macro=true";
import { default as _91slug_93GK0cJ6nyMK9NyOMwb0VsDmhHDOL4yZO6BitHySbOeiwMeta } from "/home/runner/work/hive-ui/hive-ui/pages/university/[module_id]/[slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/index.vue")
  },
  {
    name: "Identity Vault",
    path: "/vault",
    meta: vault7dvojc3_45Ljkv2G9BXy4f66egKaCj41dC0rtJ4Uk7k5gMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/vault.vue")
  },
  {
    name: "Family Protection",
    path: "/family",
    meta: familysEYAYejF7cIVasSq1YwfB_45k5ZfT_nF4mI_gD0VpfM4EMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/family.vue")
  },
  {
    name: "Exposure Details",
    path: "/details",
    meta: detailsXEy1Ih8RgAPFuflbDO2_7ppgWTzkxisJc_0zyxRvFZMMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/details.vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/reports.vue")
  },
  {
    name: "Contacts Redirect",
    path: "/contacts",
    meta: contacts5xZmvWRti_45_bpH9ioF3wbIQ9G2ARNhfqeaHvcsGJYSUMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/contacts.vue")
  },
  {
    name: "Account Settings",
    path: "/settings",
    meta: settingsLLG8Vypm1_45rrnXWYDS6564Phtljcu44QXEa_457pqXeBQMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/settings.vue"),
    children: [
  {
    name: "Limited Power of Attorney",
    path: "lpoa",
    meta: lpoaIPd_456E_vjEdF4STEF4cGkaZ_45js00mAjT3MWHhJ0wJsMMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/settings/lpoa.vue")
  },
  {
    name: "settings",
    path: "",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/settings/index.vue")
  },
  {
    name: "Billing",
    path: "billing",
    meta: billing2wBdUorGldV4Z8_45L_45CdofiRebVVaJBHYwM1USk_vgn8Meta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/settings/billing.vue")
  },
  {
    name: "Protection Level",
    path: "controls",
    meta: controls3NaNlpn86HIoNcFAW6wEotvSJveS_3oiB1Ej99equ2kMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/settings/controls.vue")
  },
  {
    name: "Account Security",
    path: "security",
    meta: securityUqcbUu8jLymX5y8Qy5mlDhj_0VaWz1fGd8e3JiU4cbYMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/settings/security.vue")
  },
  {
    name: "Monitoring",
    path: "monitoring",
    meta: monitoringEpeA2bGOZgJUrpqXN2aqrub0VjOnaMCeVWnRxj5q4ooMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/settings/monitoring.vue")
  },
  {
    name: "Notifications",
    path: "notifications",
    meta: notificationspSNAumhLS0uZWHVr8oA25xn5WVmlRL5iVFivbHGOCoQMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/settings/notifications.vue")
  }
]
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/dashboard.vue")
  },
  {
    name: "not-found",
    path: "/not-found",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/not-found.vue")
  },
  {
    name: "Login",
    path: "/auth/login",
    meta: loginN5GUm_RH2lzdErTSMBNVGscLkuSXQi9WdZOoFeifEXwMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/auth/login.vue")
  },
  {
    name: "buzz-radar",
    path: "/buzz/radar",
    meta: radarCjl1nXC0MVpdG_DMWMUhfRYscfM5kF6lTJSgJ_45nhlvEMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/buzz/radar.vue")
  },
  {
    name: "Logout",
    path: "/auth/logout",
    meta: logoutsLqxcvZTBUAGo8U0yb8QaK1tu6flvl11BVoYuNXjeokMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/auth/logout.vue")
  },
  {
    name: "DataBrokers",
    path: "/data-brokers",
    meta: data_45brokersIBGn34ciNsUPugKHQfhzya80HG6cIHXe_8q_45bakZVYAMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/data-brokers.vue")
  },
  {
    name: "Logging In",
    path: "/auth/callback",
    meta: callbackJxJppHg3Nso63D5V4IqVmYLmiRV4ZQz416Zy2hIU5d4Meta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/auth/callback.vue")
  },
  {
    name: "Dark Web Exposure Scan",
    path: "/dark-web-scan",
    meta: dark_45web_45scanSzNgHczSpieF3Rlxk9z7ml6JQjrheSSmk_45wMV_B5CiYMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/dark-web-scan.vue")
  },
  {
    name: "buzz-risk-chart",
    path: "/buzz/risk-chart",
    meta: risk_45chart4i1jJdkrc_45OnvHz0G_45BZP3OHHxzCHp03qQOtN_45cw_vIMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/buzz/risk-chart.vue")
  },
  {
    name: "Companies",
    path: "/companies",
    meta: indexRqHWElTahGBDXs9I_D174sG2Pw_45fMcQwCKeSfXMTynoMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/companies/index.vue")
  },
  {
    name: "Search Presence",
    path: "/search-presence",
    meta: search_45presence_hHoYSdj_45hopCpUuNYZZ4Wr1gqKnGDChxWK9zAMofhQMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/search-presence.vue")
  },
  {
    name: "university",
    path: "/university",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/university/index.vue")
  },
  {
    name: "personal-dashboard",
    path: "/personal/dashboard",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/personal/dashboard.vue")
  },
  {
    name: "support-lab-authed",
    path: "/support-lab/authed",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/support-lab/authed.vue")
  },
  {
    name: "support-lab-public",
    path: "/support-lab/public",
    meta: publicztsZeW0KX7spIle29YzORigSD9xEHfsf3LANcOdUJNgMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/support-lab/public.vue")
  },
  {
    name: "Data Brokers",
    path: "/brokers/:category?",
    meta: _91_91category_93_93J4u4U_Tq_45SU0oXScnu3zHegLpr1qN8KGf22iqY4AwXMMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/brokers/[[category]].vue")
  },
  {
    name: "business-slug-apps",
    path: "/business/:slug()/apps",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/business/[slug]/apps.vue")
  },
  {
    name: "business-slug",
    path: "/business/:slug()",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/business/[slug]/index.vue")
  },
  {
    name: "consent-minor-token",
    path: "/consent/minor/:token()",
    meta: _91token_93RRxVG8tuaVMvbHLEDdSHe4ZebMltnndk0s3eWar_453Q4Meta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/consent/minor/[token].vue")
  },
  {
    name: "Company Details",
    path: "/companies/:slug/:tab?",
    meta: _91tab_93oa4ikMo3GKl2wXrjV_45gTMsZDhuC0cXLUBVP3mIF1_vYMeta || {},
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/companies/[slug]/[tab].vue")
  },
  {
    name: "university-module_id-slug",
    path: "/university/:module_id()/:slug()",
    component: () => import("/home/runner/work/hive-ui/hive-ui/pages/university/[module_id]/[slug].vue")
  }
]